import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuillModule } from 'ngx-quill';
import { InfoTooltipButtonComponent } from './info-tooltip-button/info-tooltip-button.component';
import { InfoTooltipViewerComponent } from './info-tooltip-viewer/info-tooltip-viewer.component';
import { SessionMessageViewerComponent } from './session-message-viewer/session-message-viewer.component';
import { MatIconModule } from '@angular/material/icon';
import { FuseCardModule } from '@fuse/components/card';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
@NgModule({
  declarations: [
    InfoTooltipViewerComponent,
    SessionMessageViewerComponent,
    InfoTooltipButtonComponent,
  ],
  imports: [
    CommonModule,
    QuillModule,
    MatIconModule,
    FuseCardModule,
    MatButtonModule,
    MatDialogModule,
    MatDividerModule

  ],
  exports : [
    SessionMessageViewerComponent,
    InfoTooltipButtonComponent
  ]
})
export class QuillViewerModule { }
